import { QUERY_GET_MY_ORDER_IN_CLASSE } from '../../query/commande/queryCommandesByUser';
import { resolverCommandeParams } from './resolverCommandeParams';
import { ResolverCommandesVariables } from '../../../types/commande/commandeDefToUpdate';
import { UserInfo } from '../../fragments/user/user.fragments';
import { capture } from '../../../services/sentry/capture';

export const commandeResolvers = {
  updateUserCommandes: (
    _,
    variables: ResolverCommandesVariables,
    { cache }
  ) => {
    // attention à vérifier que la query est déjà requetée une fois au moins
    // sinon pas de cache
    const newParams = resolverCommandeParams(variables);
    let prev;
    try {
      prev = cache.readQuery({
        query: QUERY_GET_MY_ORDER_IN_CLASSE,
        variables: { id: variables.user }
      });
    } catch (e) {
      capture('Impossible de lire les query Commande du Cache ' + e);
      throw new Error('Impossible de lire les query Commande du Cache');
    }

    try {
      cache.writeFragment({
        id: 'UsersPermissionsUser:' + variables.user,
        fragment: UserInfo.fragments.commandes,
        data: {
          __typename: 'UsersPermissionsUser',
          ...prev,
          commandes: prev ? [...prev.user.commandes, newParams] : [newParams]
        }
      });
      //TODO classer la derniere commande en ordre chrono, changer newparmas avec ...prev.user.commandes
    } catch (e) {
      capture("Impossible d'écrire la nouvelle commande dans le cache " + e);
      throw new Error(
        "Impossible d'écrire la nouvelle commande dans le cache "
      );
    }
  }
};
